import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import store from "../store";
import router from "../router";

export default {
  install(Vue) {
    Vue.conectarSignalR = function() {
      const connection = new HubConnectionBuilder()
        .withUrl(`${process.env.VUE_APP_SERVER_URL}/hub`, { accessTokenFactory: () => store.state.sesion.usuario.token })
        .configureLogging(LogLevel.Information)
        .build();

      const hub = new Vue();

      Vue.prototype.$hub = hub;

      connection.on("RecargaConfirmada", mensaje => {
        hub.$emit("RecargaConfirmada", { ...mensaje });
      });

      connection.on("PruebaNotificacion", payload => {
        hub.$emit("PruebaNotificacion", { ...payload });
      });

      connection.on("Deshabilitar", () => {
        router.push("/");
      });

      // if connection closed, reopen it
      let startedPromise = null;
      function start() {
        startedPromise = connection.start().catch(err => {
          console.log(err);
          return new Promise((resolve, reject) =>
            setTimeout(
              () =>
                start()
                  .then(resolve)
                  .catch(reject),
              5000
            )
          );
        });
        return startedPromise;
      }

      connection.onclose(() => start());

      start();
    };

    if (store.state.sesion.usuario && store.state.sesion.usuario.token) {
      Vue.conectarSignalR();
    }
  }
};
